import 'element-closest-polyfill';
import Cookies from 'js-cookie';
const modalTriggers = document.querySelectorAll('.modalTrigger');
const modalCloseBtns = document.querySelectorAll('.jsModalBtn');
const body = document.querySelector('body');
const jsNewsletterModal = document.querySelector('.jsNewsletterModal');
let position;

if (modalTriggers) {
	const modalTriggersLen = modalTriggers.length;

	for (let i = 0; i < modalTriggersLen; i++) {
		modalTriggers[i].addEventListener('click', () => {
			// get scroll position
			position = window.pageYOffset;
			let modal = document.querySelector('.jsModal');

			modal.classList.add('active');
			body.classList.add('no-scroll');
			// keep scroll position to prevent jump
			body.style.top = `-${position}px`;
		})
	}
}

if (modalCloseBtns) {
	const modalCloseBtnsLen = modalCloseBtns.length;

	for (let j = 0; j < modalCloseBtnsLen; j++) {
		modalCloseBtns[j].addEventListener('click', () => {
			if(modalCloseBtns[j].classList.contains('jsCookie')) {
				Cookies.set('newsletterModal', 'closed', { expires: 31 })
			}

			let modal = modalCloseBtns[j].closest('.jsModal');
			let modalArea = modal.querySelector('.modal-area');
			modal.classList.remove('active');
			body.classList.remove('no-scroll');

			// remove scroll position jump fix and put back to correct position
			body.style.top = '';
			window.scrollTo(0, position);

			// prevents glitch when closing
			setTimeout( () => {
				modalArea.innerHTML = '';
			}, 300);
		})
	}
}

window.addEventListener('load', () => {
	if (jsNewsletterModal) {
		if (Cookies.get('newsletterModal') === 'closed') {
			console.log('closed');
		} else {
			jsNewsletterModal.classList.add('active');
			body.classList.add('no-scroll');
			// keep scroll position to prevent jump
			body.style.top = `-${position}px`;
		}
	}
})